import * as api from '../api';
import { SNACKBAR_DURATION_MS, getSnackbarColor } from "../utils/snackbar";

// Action Types
export const GET_MATERIAL_REQUESTS = 'GET_MATERIAL_REQUESTS';
export const GET_MATERIAL_REQUEST = 'GET_MATERIAL_REQUEST';
export const CREATE_MATERIAL_REQUEST = 'CREATE_MATERIAL_REQUEST';
export const UPDATE_MATERIAL_REQUEST = 'UPDATE_MATERIAL_REQUEST';
export const DELETE_MATERIAL_REQUEST = 'DELETE_MATERIAL_REQUEST';

// Get all material requests
export const getMaterialRequests = (searchQuery, page, pageSize) => async (dispatch) => {
  try {
    const { data } = await api.fetchMaterialRequests(searchQuery, page, pageSize);
    
    dispatch({ 
      type: GET_MATERIAL_REQUESTS, 
      payload: data 
    });
    
    return data;
  } catch (error) {
    console.error('Error fetching material requests:', error);
    throw error;
  }
};

// Get pending material requests
export const getPendingMaterialRequests = () => async (dispatch) => {
  try {
    const { data } = await api.fetchPendingMaterialRequests();
    
    return data;
  } catch (error) {
    console.error('Error fetching pending material requests:', error);
    throw error;
  }
};

// Get single material request
export const getMaterialRequest = (id) => async (dispatch) => {
  try {
    const { data } = await api.fetchMaterialRequest(id);
    
    dispatch({ 
      type: GET_MATERIAL_REQUEST, 
      payload: data 
    });
    
    return data;
  } catch (error) {
    console.error('Error fetching material request:', error);
    throw error;
  }
};

// Create material request
export const createMaterialRequest = (requestData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.createMaterialRequest(requestData);
    
    dispatch({ 
      type: CREATE_MATERIAL_REQUEST, 
      payload: data 
    });
    
    openSnackbar('Material request created successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Material request created successfully"));
    
    return data;
  } catch (error) {
    console.error('Error creating material request:', error);
    openSnackbar('Error creating material request', SNACKBAR_DURATION_MS, getSnackbarColor("Error creating material request"));
    throw error;
  }
};

// Update material request
export const updateMaterialRequest = (id, requestData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.updateMaterialRequest(id, requestData);
    
    dispatch({ 
      type: UPDATE_MATERIAL_REQUEST, 
      payload: data 
    });
    
    openSnackbar('Material request updated successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Material request updated successfully"));
    
    return data;
  } catch (error) {
    console.error('Error updating material request:', error);
    openSnackbar('Error updating material request', SNACKBAR_DURATION_MS, getSnackbarColor("Error updating material request"));
    throw error;
  }
};

// Delete material request
export const deleteMaterialRequest = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteMaterialRequest(id);
    
    dispatch({ 
      type: DELETE_MATERIAL_REQUEST, 
      payload: id 
    });
    
    openSnackbar('Material request deleted successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Material request deleted successfully"));
  } catch (error) {
    console.error('Error deleting material request:', error);
    openSnackbar('Error deleting material request', SNACKBAR_DURATION_MS, getSnackbarColor("Error deleting material request"));
    throw error;
  }
};

// Submit material request
export const submitMaterialRequest = (id, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.submitMaterialRequest(id);
    
    dispatch({ 
      type: UPDATE_MATERIAL_REQUEST, 
      payload: data 
    });
    
    openSnackbar('Material request submitted successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Material request submitted successfully"));
    
    return data;
  } catch (error) {
    console.error('Error submitting material request:', error);
    openSnackbar('Error submitting material request', SNACKBAR_DURATION_MS, getSnackbarColor("Error submitting material request"));
    throw error;
  }
};

// Approve material request
export const approveMaterialRequest = (id, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.approveMaterialRequest(id);
    
    dispatch({ 
      type: UPDATE_MATERIAL_REQUEST, 
      payload: data 
    });
    
    openSnackbar('Material request approved successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Material request approved successfully"));
    
    return data;
  } catch (error) {
    console.error('Error approving material request:', error);
    openSnackbar('Error approving material request', SNACKBAR_DURATION_MS, getSnackbarColor("Error approving material request"));
    throw error;
  }
};

// Reject material request
export const rejectMaterialRequest = (id, reason, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.rejectMaterialRequest(id, { reason });
    
    dispatch({ 
      type: UPDATE_MATERIAL_REQUEST, 
      payload: data 
    });
    
    openSnackbar('Material request rejected', SNACKBAR_DURATION_MS, getSnackbarColor("Material request rejected"));
    
    return data;
  } catch (error) {
    console.error('Error rejecting material request:', error);
    openSnackbar('Error rejecting material request', SNACKBAR_DURATION_MS, getSnackbarColor("Error rejecting material request"));
    throw error;
  }
};

// Issue materials
export const issueMaterials = (id, issueData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.issueMaterials(id, issueData);
    
    dispatch({ 
      type: UPDATE_MATERIAL_REQUEST, 
      payload: data 
    });
    
    openSnackbar('Materials issued successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Materials issued successfully"));
    
    return data;
  } catch (error) {
    console.error('Error issuing materials:', error);
    openSnackbar('Error issuing materials', SNACKBAR_DURATION_MS, getSnackbarColor("Error issuing materials"));
    throw error;
  }
};
